import * as _ from 'underscore';
import { SelectableOptions } from '../../interfaces/options/selectable';
import { DefaultSelectableOptions } from '../../const/defaultOptions';

export class Selectable {
	public isSelected: KnockoutObservable<boolean>;
	public id: string;
	public template: KnockoutObservable<string>;
	constructor(options: SelectableOptions) {
		this.initSelectable(options);
	}
	public initSelectable(options: SelectableOptions) {
		_.defaults(options, DefaultSelectableOptions);
		this.id = options.id;
		this.isSelected = ko.observable<boolean>(options.isSelected);
		this.template = ko.observable<string>(options.template);
	}
	public setSelected(isSelected: boolean) {
		this.isSelected(isSelected);
	}
}
